import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Tag } from '@wfp/ui';

import { HighlightsTitle, type Section, sectionActionReject, SectionState, Topic } from '../../restapi/types';
import { useDedobUser } from '../../hooks/home';
import { Tipmark } from '../common/Tipmark';


interface Props {
	section: Section;
}

export function SectionSummary(props: Props) {
	const {section: s} = props;

	const user = useDedobUser();
	const navigate = useNavigate();
	const viewSection = () => navigate(`/section/${s.id}`);

	let authorLine: string | React.JSX.Element =
		(s.state === SectionState.published) ? '' :
			(s.state === SectionState.cleared) ? `Cleared by: ${s.lastAuthor}` :
				s.owner ? `Locked by: ${s.owner}` :
					s.lastAuthor ? `Last edit by: ${s.lastAuthor}` :
						'';
	authorLine = authorLine.replace(`: ${user?.username}`, ': YOU');
	authorLine = ((s.owner && (s.state !== SectionState.published)) ? '🔒 ' : '') + authorLine;
	if (authorLine.includes('Locked by: YOU')) {
		authorLine = <div>
			🔒 <Tag type="error">Locked by: YOU</Tag>
			<Tipmark>Please go back to the homepage, either by saving, submitting, or cancelling the entry. Leaving it
				open will prevent publishing!</Tipmark>
		</div>;
	}

	return (
		<tbody>
		<tr className={authorLine ? 'session has-author' : 'session'} onClick={viewSection}>
			<td>{s.topic} - {s.topic === Topic.highlights ? HighlightsTitle : s.title}</td>
			<td>
				{s.lastAction === sectionActionReject ?
					<><span className={`state-mark state-reject`}/> REVISION</>
					: <><span className={`state-mark state-${s.state}`}/>{s.stateLabel}</>
				}
			</td>
		</tr>
		{authorLine ?
			<tr className="author" onClick={viewSection}>
				<td colSpan={3}>
					{authorLine}
				</td>
			</tr> : null}
		</tbody>
	);
}